import React, { ReactNode, RefObject } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { PersonSuggester, SelectedPerson } from '../../edit/components/suggester/PersonSuggester';
import { Labelled, LabelledProps } from './Labelled';

interface LabelledPersonSuggesterProps extends LabelledProps {
  value: SelectedPerson[];
  onChange: (refs: SelectedPerson[]) => void;
  tooltip?: string;
  tooltipOptions?: any;
  pattern?: string;
  autoFocus?: boolean;
  className?: string;
  multiple: boolean;
  border?: 'border-noround' | 'border-noround-right';
  ref?: RefObject<any>;
}

export const LabelledPersonSuggester = (props: LabelledPersonSuggesterProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <PersonSuggester
        value={props.value}
        autoFocus={props.autoFocus}
        inputId={props.id}
        required={props.permissions?.required || props.required}
        disabled={disabled}
        multiple={props.multiple}
        validation={props.validation}
        border={props.border}
        onChange={(refs: SelectedPerson[]): void => props.onChange(refs)}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
        ref={props.ref}
      />
    </Labelled>
  );
};
